<!--  -->
<template>
  <van-popup class="popupDraw" v-model="show" :round="true" @click-overlay="close">
    <div class="gift">
      <img
        class="bg"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/funGame/giftbg.png"
      />
    </div>
  </van-popup>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: true,
    };
  },
  computed: {},
  watch: {},
  methods: {
    close() {
      this.$parent.showReward = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.popupDraw {
  background: none;
  border-radius: 36px !important;
}
.gift {
  position: relative;
  .bg {
    display: block;
    width:500px;
    height:644px;
    margin: 0 auto;
  }
}
</style>
